import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import TopUpRequestTable from '../../../components/tables/TopUpRequestTable';

const formatDate = (date) => date.toISOString().split('T')[0];

const parseDate = (value) => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const dummyTopUpRequests = [
  {
    id: 'TUR0001',
    userName: 'Rohit Sharma',
    date: '2025-10-28',
    amount: 50000,
    mode: 'NEFT',
    orderId: 'ORD123456',
    utr: 'UTR9988776655',
    bank: 'HDFC Bank',
    transDate: '2025-10-27',
    remark: 'Settlement for month end',
    reason: '',
    parentId: { mobile: '9876543210' },
    userId: { mobile: '9123456780' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '10:15 AM',
  },
  {
    id: 'TUR0002',
    userName: 'Anjali Verma',
    date: '2025-10-27',
    amount: 22500,
    mode: 'UPI',
    orderId: 'ORD123457',
    utr: 'UTR9988776644',
    bank: 'ICICI Bank',
    transDate: '2025-10-26',
    remark: 'October top-up',
    reason: '',
    parentId: { mobile: '9988776655' },
    userId: { mobile: '9822334455' },
    status: 'Approved',
    approvedBy: 'Admin1',
    approvedDate: '2025-10-27',
    recorn: 'Yes',
    time: '02:45 PM',
  },
  {
    id: 'TUR0003',
    userName: 'Vikas Mehra',
    date: '2025-10-25',
    amount: 15000,
    mode: 'IMPS',
    orderId: 'ORD123458',
    utr: 'UTR9988776633',
    bank: 'Axis Bank',
    transDate: '2025-10-25',
    remark: 'Urgent balance request',
    reason: 'Transaction mismatch resolved',
    parentId: { mobile: '9765432109' },
    userId: { mobile: '9345678901' },
    status: 'Rejected',
    approvedBy: 'Admin2',
    approvedDate: '2025-10-26',
    recorn: 'No',
    time: '11:05 AM',
  },
  {
    id: 'TUR0004',
    userName: 'Neha Gupta',
    date: '2025-10-24',
    amount: 78000,
    mode: 'RTGS',
    orderId: 'ORD123459',
    utr: 'UTR9988776622',
    bank: 'State Bank of India',
    transDate: '2025-10-24',
    remark: 'High volume payout',
    reason: '',
    parentId: { mobile: '9123009876' },
    userId: { mobile: '9001122233' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '09:30 AM',
  },
  {
    id: 'TUR0005',
    userName: 'Imran Khan',
    date: '2025-10-23',
    amount: 32000,
    mode: 'Cheque',
    orderId: 'ORD123460',
    utr: 'UTR9988776611',
    bank: 'Kotak Mahindra Bank',
    transDate: '2025-10-22',
    remark: 'Cheque clearance pending',
    reason: '',
    parentId: { mobile: '9898989898' },
    userId: { mobile: '9333444455' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Pending',
    time: '04:20 PM',
  },
  {
    id: 'TUR0006',
    userName: 'Priya Singh',
    date: '2025-10-22',
    amount: 45000,
    mode: 'NEFT',
    orderId: 'ORD123461',
    utr: 'UTR9988776600',
    bank: 'Union Bank of India',
    transDate: '2025-10-22',
    remark: 'Monthly limit renewal',
    reason: '',
    parentId: { mobile: '9777665544' },
    userId: { mobile: '9556677889' },
    status: 'Approved',
    approvedBy: 'Admin3',
    approvedDate: '2025-10-23',
    recorn: 'Yes',
    time: '01:10 PM',
  },
  {
    id: 'TUR0007',
    userName: 'Karan Patel',
    date: '2025-10-20',
    amount: 12000,
    mode: 'UPI',
    orderId: 'ORD123462',
    utr: 'UTR9988776599',
    bank: 'Yes Bank',
    transDate: '2025-10-20',
    remark: 'Quick top-up',
    reason: '',
    parentId: { mobile: '9445566778' },
    userId: { mobile: '9887766554' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '12:00 PM',
  },
  {
    id: 'TUR0008',
    userName: 'Shreya Kulkarni',
    date: '2025-10-18',
    amount: 61000,
    mode: 'IMPS',
    orderId: 'ORD123463',
    utr: 'UTR9988776588',
    bank: 'IDFC First Bank',
    transDate: '2025-10-18',
    remark: 'Festival season demand',
    reason: 'Approved post verification',
    parentId: { mobile: '9554433221' },
    userId: { mobile: '9112233445' },
    status: 'Approved',
    approvedBy: 'Admin1',
    approvedDate: '2025-10-19',
    recorn: 'Yes',
    time: '05:55 PM',
  },
];

const dummyDateRange = dummyTopUpRequests.reduce(
  (range, record) => {
    const requestDate = parseDate(record?.date) || parseDate(record?.transDate);

    if (!requestDate) {
      return range;
    }

    const next = { ...range };

    if (!next.min || requestDate < next.min) {
      next.min = requestDate;
    }

    if (!next.max || requestDate > next.max) {
      next.max = requestDate;
    }

    return next;
  },
  { min: null, max: null }
);

const defaultFromDate = dummyDateRange.min ? formatDate(dummyDateRange.min) : formatDate(new Date());
const defaultToDate = dummyDateRange.max ? formatDate(dummyDateRange.max) : formatDate(new Date());

const createDefaultFilters = () => ({
  fromDate: defaultFromDate,
  toDate: defaultToDate,
  searchValue: '',
  pageNumber: 0,
  pageSize: 10,
});

const TopUpRequest = () => {
  const defaultFilters = useMemo(() => createDefaultFilters(), []);

  const [filters, setFilters] = useState(defaultFilters);
  const [allRequests, setAllRequests] = useState(dummyTopUpRequests);
  const [requestsData, setRequestsData] = useState([]);
  const [meta, setMeta] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: defaultFilters.pageSize,
  });
  useEffect(() => {
    const from = parseDate(filters.fromDate);
    const to = parseDate(filters.toDate);
    const normalizedSearch = filters.searchValue?.trim().toLowerCase() ?? '';

    const filterByDate = (request) => {
      const requestDate = parseDate(request?.date) || parseDate(request?.transDate);

      if (!from && !to) {
        return true;
      }

      if (!requestDate) {
        return false;
      }

      if (from && requestDate < from) {
        return false;
      }

      if (to) {
        const normalizedTo = new Date(to);
        normalizedTo.setHours(23, 59, 59, 999);
        if (requestDate > normalizedTo) {
          return false;
        }
      }

      return true;
    };

    const includesSearchValue = (request) => {
      if (!normalizedSearch) {
        return true;
      }

      const searchInValue = (value) => {
        if (value === null || value === undefined) {
          return false;
        }

        if (typeof value === 'object') {
          return Object.values(value).some((nested) => searchInValue(nested));
        }

        return String(value).toLowerCase().includes(normalizedSearch);
      };

      return Object.values(request).some(searchInValue);
    };

    const filtered = allRequests.filter((request) => filterByDate(request) && includesSearchValue(request));

    const totalRecords = filtered.length;
    const totalPages = totalRecords > 0 ? Math.ceil(totalRecords / filters.pageSize) : 0;
    const lastPageIndex = Math.max(totalPages - 1, 0);
    const currentPage = Math.min(Math.max(filters.pageNumber, 0), lastPageIndex);
    const startIndex = currentPage * filters.pageSize;
    const pageSlice = filtered.slice(startIndex, startIndex + filters.pageSize);

    setRequestsData(pageSlice);
    setMeta({
      totalRecords,
      totalPages,
      currentPage,
      pageSize: filters.pageSize,
    });

    if (currentPage !== filters.pageNumber) {
      setFilters((prev) => ({ ...prev, pageNumber: currentPage }));
    }
  }, [allRequests, filters]);

  const handleDateChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      pageNumber: 0,
    }));
  };

  const handleSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      searchValue: value,
      pageNumber: 0,
    }));
  };

  const handleTableDataChange = (updatedPageData = []) => {
    if (!Array.isArray(updatedPageData)) {
      return;
    }

    setAllRequests((prev) => {
      const next = [...prev];
      const indexById = new Map(next.map((item, index) => [item.id, index]));

      updatedPageData.forEach((item) => {
        if (!item || !item.id) {
          return;
        }

        if (indexById.has(item.id)) {
          const idx = indexById.get(item.id);
          next[idx] = { ...next[idx], ...item };
        } else {
          next.unshift(item);
        }
      });

      return next;
    });
  };

  const handlePageChange = (pageNumber) => {
    setFilters((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setFilters((prev) => ({
      ...prev,
      pageSize,
      pageNumber: 0,
    }));
  };

  return (
    <Container fluid className="">
      <TopUpRequestTable
        data={requestsData}
        loading={false}
        pagination={{
          totalRecords: meta.totalRecords,
          pageSize: filters.pageSize,
          currentPage: meta.currentPage,
          totalPages: meta.totalPages,
        }}
        onDataChange={handleTableDataChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        searchValue={filters.searchValue}
        onSearch={handleSearch}
        fromDate={filters.fromDate}
        toDate={filters.toDate}
        onDateChange={handleDateChange}
      />
    </Container>
  );
};

export default TopUpRequest;

